import React from 'react';
import styles from './chartTimePeriod.module.scss';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import adobeTags from 'src/types/adobe-tags';
import { BudgetPages } from 'src/components/atomic/pages/BudgetPages';
import Selectors from 'src/utils/selectors';
import { LocalDate } from '@js-joda/core';
import FormatService from 'src/services/format.service';
import useCurrentUser from 'src/hooks/useCurrentUser';
import { useHistory } from 'react-router-dom';
import H from 'history';
import { useVisibleAccounts } from 'src/hooks/queries/accounts';
import { goToSettings } from 'src/services/router.service';

interface ChartTimePeriodProps {
    startDate: LocalDate;
    endDate: LocalDate;
    propHistory?: H.History;
}

export default function ChartTimePeriod({ startDate, endDate, propHistory }: ChartTimePeriodProps): JSX.Element {
    const { isFullPlanUser } = useCurrentUser();
    const { isLoading: isLoadingVisibleAccounts, data: visibleAccounts } = useVisibleAccounts();
    const history = useHistory();

    return (
        <div className={styles.period}>
            <Typography
                variant={TypographyVariants.BODY_BOLD}
                component="p"
                data-cy={Selectors.SpendSmart.CHART_TIME_PERIOD}
            >
                {FormatService.formatMonthDayYearAbbreviated(startDate)} –{' '}
                {FormatService.formatMonthDayYearAbbreviated(endDate)}
            </Typography>
            <span className={styles.hideOnMobile}>•</span>
            <Typography
                variant={TypographyVariants.BODY}
                component="p"
                aria-live="polite"
                aria-busy={isLoadingVisibleAccounts}
            >
                {LiteralsService.getLiteral('PageOrientation.basedOn')}
                {isLoadingVisibleAccounts ? (
                    '--'
                ) : (
                    <Anchor
                        onClick={() => goToSettings(isFullPlanUser, propHistory || history)}
                        tag={adobeTags.General.NAccounts}
                        href={BudgetPages.SETTINGS}
                        data-cy={Selectors.SpendSmart.NUM_ACCOUNT_LINK}
                        aria-label={LiteralsService.getLiteral('Budget.Current.accountNumberLinkDescription', [
                            visibleAccounts?.length
                        ])}
                        inline
                    >
                        {LiteralsService.getLiteral('PageOrientation.numAccounts', [visibleAccounts?.length || 0])}
                    </Anchor>
                )}
            </Typography>
        </div>
    );
}
